// Fix for ResizeObserver loop errors
// This error occurs when ResizeObserver cannot deliver all notifications within a single animation frame
// It's a known browser issue and is generally harmless

const debounce = (callback, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};

// Create a patched ResizeObserver that debounces notifications
if (typeof window !== 'undefined' && window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    
    window.ResizeObserver = class DebouncedResizeObserver {
        constructor(callback) {
            this.observer = new OriginalResizeObserver(debounce(callback, 20));
        }
        
        observe(...args) {
            return this.observer.observe(...args);
        }
        
        unobserve(...args) {
            return this.observer.unobserve(...args);
        }
        
        disconnect() {
            return this.observer.disconnect();
        }
    };
    
    // Copy static properties
    Object.setPrototypeOf(window.ResizeObserver, OriginalResizeObserver);
    Object.setPrototypeOf(window.ResizeObserver.prototype, OriginalResizeObserver.prototype);
}

const resizeObserverFix = {};
export default resizeObserverFix;